import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './index.styl';

const EMBED_LINK = 'https://www.youtube.com/embed/';

function YoutubeVideo({ videoId, isShorts }) {
  return (
    <div className={cx(styles.frameWrapper, isShorts && styles._shorts)}>
      <iframe
        className={styles.frame}
        src={EMBED_LINK + videoId}
        allowFullScreen
        frameBorder='0'
      />
    </div>
  );
}

YoutubeVideo.propTypes = {
  videoId: PropTypes.string,
  isShorts: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default YoutubeVideo;
